module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/filetypes-zip-19b442d953f00c74dc7e6576b652b9ea.svg";